module.exports = __webpack_public_path__ + "img/pic_xiaomistepone.db1788a2.png";